<script>

import ProfileReports from "./Reports/ProfileReports.vue";
import ProfileCalendar from "./Calendar/ProfileCalendar.vue";
import ProfileNotRegistered from "./ProfileNotRegistered.vue";
import {mapMutations} from "vuex";
import axios from "axios";
import {ensureSanctumSession, notifyMiniAppReady} from "../../miniAppAjax.js";

const MAX_AUTH_INTERCEPTOR_FLAG = Symbol.for('rentou.maxAuthInterceptor')

export default {
  name: "Profile",
  components: {ProfileReports, ProfileCalendar, ProfileNotRegistered},
  data(){
    return {
      menu:false,
      profileGuestState: null,
    }
  },
  computed:{
    smartMenu(){
      return this.menu
    }
  },
  methods: {
    changeProfileMenu(menu){
      this.menu = menu;
    },
    miniAppInitPayload() {
      const tg = typeof window !== 'undefined' && window.Telegram && window.Telegram.WebApp
      const maxApp = typeof window !== 'undefined' && window.WebApp
      if (tg && tg.initData) {
        tg.setHeaderColor('#fff')
        tg.setBackgroundColor('#323232')
        tg.expand()
        return { mini_app_provider: 'telegram', userData: tg.initData }
      }
      if (maxApp && maxApp.initData) {
        return { mini_app_provider: 'max', userData: maxApp.initData }
      }
      return null
    },
    fmtAxiosErr(error) {
      let s = (error && error.message) ? error.message : String(error)
      if (error && error.response) {
        s += '\nHTTP ' + error.response.status
        const d = error.response.data
        if (d !== undefined) {
          s += '\n' + (typeof d === 'string' ? d : JSON.stringify(d))
        }
      }
      return s
    },
    async queryGetListContract (apiPrefix = '/api/telegram') {
      const response = await this.axios.get(apiPrefix + '/get-list-contract')
      const body = response.data || {}
      if (body.success === false) {
        throw new Error(body.message || 'Не удалось загрузить договоры')
      }
      const list = Array.isArray(body.data) ? body.data : []
      if (list.length === 0) {
        this.setContracts([])
        this.setSelectContract(null)
        this.profileGuestState = 'not_in_system'
        return
      }
      this.setContracts(list)
      this.setSelectContract(list[0])
      this.changeProfileMenu('reports')
    },
    async bootstrapProfile() {
      try {
        notifyMiniAppReady()
        await ensureSanctumSession(this.axios)

        const init = this.miniAppInitPayload()
        if (!init) {
          const tg = typeof window !== 'undefined' && window.Telegram && window.Telegram.WebApp
          const maxApp = typeof window !== 'undefined' && window.WebApp
          const diag = [
            '[MiniApp] Нет initData — логин не отправлен.',
            'Telegram.WebApp: ' + (tg ? 'да' : 'нет'),
            'Telegram initData длина: ' + (tg && tg.initData ? tg.initData.length : 0),
            'MAX window.WebApp: ' + (maxApp ? 'да' : 'нет'),
            'MAX initData длина: ' + (maxApp && maxApp.initData ? maxApp.initData.length : 0),
            maxApp && maxApp.platform ? 'MAX platform: ' + maxApp.platform : ''
          ].filter(Boolean).join('\n')
          console.warn(diag)
          if (this.$router && this.$route.path !== '/') {
            void this.$router.push({ path: '/' })
          }
          return
        }

        const loginRes = await this.axios.post('/api/login', {
          telegram_user: init.userData,
          mini_app_provider: init.mini_app_provider
        })

        if (!loginRes.data.success) {
          const code = loginRes.data && loginRes.data.code
          if (code === 'user_not_registered') {
            this.profileGuestState = 'not_in_system'
            return
          }
          const msg = (loginRes.data && loginRes.data.message) ? loginRes.data.message : 'Ошибка аутентификации'
          console.warn('[api/login] success=false', { mini_app_provider: init.mini_app_provider, msg })
          if (typeof window.Alerts !== 'undefined') {
            window.Alerts.error(msg, 'topRight', false)
          }
          return
        }

        let profileUser = loginRes.data.data
        if (!profileUser) {
          await new Promise((resolve) => setTimeout(resolve, 3000))
          const userRes = await this.axios.get('/api/user')
          profileUser = userRes.data.data
        }
        if (!profileUser) {
          console.warn('[profile] /api/login успешен, но пользователь не в ответе и /api/user вернул null — проверьте Cookie/session (повтор curl без Cookie даёт тот же эффект).')
          if (typeof window.Alerts !== 'undefined') {
            window.Alerts.error('Сессия не сохранилась. Откройте приложение снова или проверьте настройки WebView.', 'topRight', false)
          }
          return
        }

        const apiPrefix = init.mini_app_provider === 'max' ? '/api/max' : '/api/telegram'
        this.setProfileApiPrefix(apiPrefix)

        if (init.mini_app_provider === 'max' && loginRes.data.max_token) {
          sessionStorage.setItem('max_auth_token', loginRes.data.max_token)
          if (!axios[MAX_AUTH_INTERCEPTOR_FLAG]) {
            axios[MAX_AUTH_INTERCEPTOR_FLAG] = true
            axios.interceptors.request.use((config) => {
              const t = sessionStorage.getItem('max_auth_token')
              if (t) {
                config.headers['X-Max-Auth-Token'] = t
              }
              return config
            })
          }
        }

        this.setUser(profileUser)
        this.setAuth()
        await this.queryGetListContract(apiPrefix)
      } catch (error) {
        const detail = this.fmtAxiosErr(error)
        console.error(error)
        console.warn('[profile] ошибка последовательной авторизации/загрузки', detail)
        if (typeof window.Alerts !== 'undefined') {
          window.Alerts.error(detail.split('\n')[0] || 'Ошибка загрузки профиля', 'topRight', false)
        }
      }
    },
    ...mapMutations(['setSelectContract', 'setContracts', 'setUser', 'setAuth', 'setProfileApiPrefix'])
  },
  created(){
    this.bootstrapProfile()
  }
}
</script>

<template>
  <ProfileNotRegistered v-if="profileGuestState === 'not_in_system'" />
  <div v-else class="wrapper-content profile left">
    <div class="btn-profile-components left">
      <span class="btn-reports left  flex flex-xy-center"
            @click.prevent="changeProfileMenu('reports')"
            :class="{active:smartMenu === 'reports'}"
      >Отчёты</span>
      <span class="btn-calendar left flex flex-xy-center"
            @click.prevent="changeProfileMenu('calendar')"
            :class="{active:smartMenu === 'calendar'}"
      >Календарь</span>
    </div>
    <Transition name="fade" mode="out-in">
      <ProfileReports v-if="menu === 'reports'" key="profileReports"></ProfileReports>
      <ProfileCalendar v-if="menu === 'calendar'" key="profileCalendar"></ProfileCalendar>
    </Transition>

  </div>
</template>

<style scoped>

</style>